import moment from 'moment';

moment.locale('fi', {
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH.mm.ss',
    L: 'DD.MM.YYYY',
    LL: 'Do MMMM[ta] YYYY',
    LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
    LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
    l: 'D.M.YYYY',
    ll: 'Do MMM YYYY',
    lll: 'Do MMM YYYY, [klo] HH.mm',
    llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
  },
});

export const getCurrentTimeString = () => moment().format('LT');

export const getTimeStringOneHoursFromNow = () => moment().add(1, 'hour').format('LT'); // eslint-disable-line

export const getCurrentDateString = () => moment().format('L');

export const getDateString15DaysFromNow = () => moment().add(15, 'days').format('L'); // eslint-disable-line

export const getValueTicketExpirationDuration = (zones) => {
  switch (zones) {
    case 'ABCD':
      return 110;
    case 'BCD':
      return 100;
    case 'ABC':
    case 'CD':
      return 90;
    case 'AB':
    case 'BC':
    case 'D':
    default:
      return 80;
  }
};

export const getTicketExpirationStringForZones = (zones) => {
  const durationInMinutes = getValueTicketExpirationDuration(zones);
  return moment().add(durationInMinutes, 'minutes').format('LT'); // eslint-disable-line
};
